import { Injectable } from '@angular/core';
import { CustomerService } from 'src/api/services/customer.service';
import { Customer } from 'src/api/models/customer';
import { BehaviorSubject, Observable, Subscription } from "rxjs";
import { StrictHttpResponse } from 'src/api/strict-http-response';
import { CommandService, FireForesightService, SiteTwinService } from 'src/api/services';
import { Camera, Incident, MapLayerItem, ResponsibleParty, SiteTwin, StatusType } from 'src/api/models';

import { HubConnection, HubConnectionBuilder, HubConnectionState, LogLevel } from '@microsoft/signalr';

/*
The DashboardEventService is intended to handle the management of events between different widgets on a dashboard.
For instance, allow you to select a site on a map and highlight that related data in a graph widget.
*/
@Injectable()
export class DashboardEventService {
    
    constructor() {
      
    }

    callbacks: { [key: string]: Array<(uri: string | null, data: any) => void> } = {};

    public on(eventType: string,  callback: (uri: string | null, data: any) => void) {
      // track the callback internaly
      if (!this.callbacks[eventType]) {
        this.callbacks[eventType] = [];
      }      
      this.callbacks[eventType].push(callback);
    }

    public trigger(eventType: string, uri: string | null | any, data: any) {
      // invoke all registered callbacks for this event type
      console.log("Triggering event ", eventType, " for uri ", uri, " with data ", data);
      if (this.callbacks[eventType]) {
        this.callbacks[eventType].forEach(callback => { 
          callback(uri, data);
        });
      }
    }   
}
